var _mask, _path, _path2, _rect, _rect2, _rect3, _mask2, _path3, _path4, _mask3, _path5, _path6, _g, _mask4, _path7, _path8, _mask5, _path9, _path0, _g2, _mask6, _path1, _path10, _mask7, _path11, _path12, _g3, _rect4, _rect5, _rect6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomePrompt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 92,
    viewBox: "0 0 121 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_35253_123952",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H113C117.418 0 121 3.58172 121 8V84C121 88.4183 117.418 92 113 92H8C3.58172 92 0 88.4183 0 84V8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H113C117.418 0 121 3.58172 121 8V84C121 88.4183 117.418 92 113 92H8C3.58172 92 0 88.4183 0 84V8Z",
    fill: "url(#paint0_linear_35253_123952)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1H113V-1H8V1ZM120 8V84H122V8H120ZM113 91H8V93H113V91ZM1 84V8H-1V84H1ZM8 91C4.134 91 1 87.866 1 84H-1C-1 88.9706 3.02943 93 8 93V91ZM120 84C120 87.866 116.866 91 113 91V93C117.971 93 122 88.9706 122 84H120ZM113 1C116.866 1 120 4.13401 120 8H122C122 3.02944 117.971 -1 113 -1V1ZM8 -1C3.02944 -1 -1 3.02944 -1 8H1C1 4.13401 4.13401 1 8 1V-1Z",
    fill: "#CFCFCF",
    mask: "url(#path-1-inside-1_35253_123952)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 18.5,
    width: 87,
    height: 55,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 18.5,
    width: 87,
    height: 55,
    rx: 3.5,
    stroke: "#CFCFCF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 37,
    width: 22,
    height: 31,
    rx: 2,
    fill: "#E1E1E1"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_35253_123952",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 38.5C48 37.9477 48.4477 37.5 49 37.5H66.5V45.5H49C48.4477 45.5 48 45.0523 48 44.5V38.5Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38.5C48 37.9477 48.4477 37.5 49 37.5H66.5V45.5H49C48.4477 45.5 48 45.0523 48 44.5V38.5Z",
    fill: "#E1E1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37.5H66.5H48ZM66.9 45.9H49.4C48.6268 45.9 48 45.2732 48 44.5C48 44.8314 48.4477 45.1 49 45.1H66.1L66.9 45.9ZM48 45.5V37.5V45.5ZM66.9 37.5V45.9L66.1 45.1V37.5H66.9Z",
    fill: "#D2D2D2",
    mask: "url(#path-5-inside-2_35253_123952)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_35253_123952",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5 37.5H84C84.5523 37.5 85 37.9477 85 38.5V44.5C85 45.0523 84.5523 45.5 84 45.5H66.5V37.5Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 37.5H84C84.5523 37.5 85 37.9477 85 38.5V44.5C85 45.0523 84.5523 45.5 84 45.5H66.5V37.5Z",
    fill: "#E1E1E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 37.5H85H66.5ZM85 44.5C85 45.2732 84.3732 45.9 83.6 45.9H66.5V45.1H84C84.5523 45.1 85 44.8314 85 44.5ZM66.5 45.5V37.5V45.5ZM85 37.5V45.5V37.5Z",
    fill: "#D2D2D2",
    mask: "url(#path-7-inside-3_35253_123952)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35253_123952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.8974 41.5022C94.8974 39.6272 93.3774 38.1072 91.5024 38.1072C89.6274 38.1072 88.1074 39.6272 88.1074 41.5022C88.1074 43.3772 89.6274 44.8972 91.5024 44.8972C93.3774 44.8972 94.8974 43.3772 94.8974 41.5022Z",
    fill: "#EFEFEF",
    stroke: "#D2D2D2",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.62 41.96C89.62 41.732 89.72 41.572 89.82 41.476C89.88 41.42 89.944 41.376 90.02 41.34C89.964 41.304 89.912 41.264 89.868 41.216C89.792 41.132 89.72 41.012 89.72 40.84C89.72 40.48 90.04 40.16 90.52 40.16C91 40.16 91.32 40.48 91.32 40.84C91.32 41.012 91.244 41.132 91.168 41.216C91.124 41.264 91.072 41.304 91.02 41.34C91.096 41.376 91.16 41.42 91.22 41.476C91.32 41.572 91.42 41.732 91.42 41.96C91.42 42.36 91.064 42.72 90.52 42.72C89.976 42.72 89.62 42.36 89.62 41.96ZM90.1 41.94C90.1 42.144 90.26 42.3 90.52 42.3C90.78 42.3 90.94 42.144 90.94 41.94C90.94 41.736 90.78 41.58 90.52 41.58C90.26 41.58 90.1 41.736 90.1 41.94ZM90.18 40.88C90.18 41.04 90.316 41.18 90.52 41.18C90.724 41.18 90.86 41.04 90.86 40.88C90.86 40.72 90.724 40.58 90.52 40.58C90.316 40.58 90.18 40.72 90.18 40.88ZM91.5591 42H92.0391C92.0591 42.12 92.2151 42.28 92.4391 42.28C92.6991 42.28 92.8791 42.1 92.8791 41.84C92.8791 41.58 92.6991 41.4 92.4391 41.4C92.2951 41.4 92.1951 41.468 92.1311 41.532C92.0951 41.568 92.0631 41.612 92.0391 41.66H91.6191L91.7791 40.18H93.1791V40.64H92.1791L92.1191 41.1C92.1551 41.08 92.1911 41.06 92.2351 41.04C92.3031 41.012 92.3991 40.98 92.4991 40.98C92.9991 40.98 93.3591 41.34 93.3591 41.84C93.3591 42.336 92.9791 42.72 92.4391 42.72C91.9351 42.72 91.6031 42.38 91.5591 42Z",
    fill: "#02BD8E"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-4_35253_123952",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 49.5C48 48.9477 48.4477 48.5 49 48.5H66.5V56.5H49C48.4477 56.5 48 56.0523 48 55.5V49.5Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49.5C48 48.9477 48.4477 48.5 49 48.5H66.5V56.5H49C48.4477 56.5 48 56.0523 48 55.5V49.5Z",
    fill: "#E1E1E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48.5H66.5H48ZM66.9 56.9H49.4C48.6268 56.9 48 56.2732 48 55.5C48 55.8314 48.4477 56.1 49 56.1H66.1L66.9 56.9ZM48 56.5V48.5V56.5ZM66.9 48.5V56.9L66.1 56.1V48.5H66.9Z",
    fill: "#D2D2D2",
    mask: "url(#path-11-inside-4_35253_123952)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-5_35253_123952",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5 48.5H84C84.5523 48.5 85 48.9477 85 49.5V55.5C85 56.0523 84.5523 56.5 84 56.5H66.5V48.5Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 48.5H84C84.5523 48.5 85 48.9477 85 49.5V55.5C85 56.0523 84.5523 56.5 84 56.5H66.5V48.5Z",
    fill: "#E1E1E1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 48.5H85H66.5ZM85 55.5C85 56.2732 84.3732 56.9 83.6 56.9H66.5V56.1H84C84.5523 56.1 85 55.8314 85 55.5ZM66.5 56.5V48.5V56.5ZM85 48.5V56.5V48.5Z",
    fill: "#D2D2D2",
    mask: "url(#path-13-inside-5_35253_123952)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_35253_123952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.8974 52.5022C94.8974 50.6272 93.3774 49.1072 91.5024 49.1072C89.6274 49.1072 88.1074 50.6272 88.1074 52.5022C88.1074 54.3772 89.6274 55.8972 91.5024 55.8972C93.3774 55.8972 94.8974 54.3772 94.8974 52.5022Z",
    fill: "#EFEFEF",
    stroke: "#D2D2D2",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.74 53.7L90.7 51.64H89.62V51.18H91.24V51.54L90.24 53.7H89.74ZM91.3598 53H91.8398C91.8598 53.12 92.0158 53.28 92.2398 53.28C92.4998 53.28 92.6798 53.1 92.6798 52.84C92.6798 52.58 92.4998 52.4 92.2398 52.4C92.0958 52.4 91.9958 52.468 91.9318 52.532C91.8958 52.568 91.8638 52.612 91.8398 52.66H91.4198L91.5798 51.18H92.9798V51.64H91.9798L91.9198 52.1C91.9558 52.08 91.9918 52.06 92.0358 52.04C92.1038 52.012 92.1998 51.98 92.2998 51.98C92.7998 51.98 93.1598 52.34 93.1598 52.84C93.1598 53.336 92.7798 53.72 92.2398 53.72C91.7358 53.72 91.4038 53.38 91.3598 53Z",
    fill: "#EFB604"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-6_35253_123952",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 60.5C48 59.9477 48.4477 59.5 49 59.5H66.5V67.5H49C48.4477 67.5 48 67.0523 48 66.5V60.5Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60.5C48 59.9477 48.4477 59.5 49 59.5H66.5V67.5H49C48.4477 67.5 48 67.0523 48 66.5V60.5Z",
    fill: "#E1E1E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48 59.5H66.5H48ZM66.9 67.9H49.4C48.6268 67.9 48 67.2732 48 66.5C48 66.8314 48.4477 67.1 49 67.1H66.1L66.9 67.9ZM48 67.5V59.5V67.5ZM66.9 59.5V67.9L66.1 67.1V59.5H66.9Z",
    fill: "#D2D2D2",
    mask: "url(#path-17-inside-6_35253_123952)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-7_35253_123952",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5 59.5H84C84.5523 59.5 85 59.9477 85 60.5V66.5C85 67.0523 84.5523 67.5 84 67.5H66.5V59.5Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 59.5H84C84.5523 59.5 85 59.9477 85 60.5V66.5C85 67.0523 84.5523 67.5 84 67.5H66.5V59.5Z",
    fill: "#E1E1E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 59.5H85H66.5ZM85 66.5C85 67.2732 84.3732 67.9 83.6 67.9H66.5V67.1H84C84.5523 67.1 85 66.8314 85 66.5ZM66.5 67.5V59.5V67.5ZM85 59.5V67.5V59.5Z",
    fill: "#D2D2D2",
    mask: "url(#path-19-inside-7_35253_123952)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_35253_123952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.8974 63.5022C94.8974 61.6272 93.3774 60.1072 91.5024 60.1072C89.6274 60.1072 88.1074 61.6272 88.1074 63.5022C88.1074 65.3772 89.6274 66.8972 91.5024 66.8972C93.3774 66.8972 94.8974 65.3772 94.8974 63.5022Z",
    fill: "#EFEFEF",
    stroke: "#D2D2D2",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.62 64H90.1C90.12 64.12 90.276 64.28 90.5 64.28C90.76 64.28 90.94 64.1 90.94 63.84C90.94 63.58 90.76 63.4 90.5 63.4C90.356 63.4 90.256 63.468 90.192 63.532C90.156 63.568 90.124 63.612 90.1 63.66H89.68L89.84 62.18H91.24V62.64H90.24L90.18 63.1C90.216 63.08 90.252 63.06 90.296 63.04C90.364 63.012 90.46 62.98 90.56 62.98C91.06 62.98 91.42 63.34 91.42 63.84C91.42 64.336 91.04 64.72 90.5 64.72C89.996 64.72 89.664 64.38 89.62 64ZM92.6391 62.62C92.3591 62.62 92.0791 62.9 92.0791 63.44C92.0791 63.98 92.3591 64.26 92.6391 64.26C92.9191 64.26 93.1991 63.98 93.1991 63.44C93.1991 62.9 92.9191 62.62 92.6391 62.62ZM92.6391 62.16C93.1991 62.16 93.6791 62.64 93.6791 63.44C93.6791 64.24 93.1991 64.72 92.6391 64.72C92.0791 64.72 91.5991 64.24 91.5991 63.44C91.5991 62.64 92.0791 62.16 92.6391 62.16Z",
    fill: "#E6374C"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 22.6667,
    height: 10,
    rx: 2,
    fill: "#E1E1E1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48.667,
    y: 24,
    width: 22.6667,
    height: 10,
    rx: 2,
    fill: "#E1E1E1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 73.333,
    y: 24,
    width: 22.6667,
    height: 10,
    rx: 2,
    fill: "#E1E1E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35253_123952",
    x1: 60.5,
    y1: 0,
    x2: 60.5,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35253_123952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(87 37)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_35253_123952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(87 48)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_35253_123952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(87 59)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePrompt);
export default __webpack_public_path__ + "static/media/home-prompt.0b30ca33f9e4b0bffd0a5a48fdc4d276.svg";
export { ForwardRef as ReactComponent };